import type { DocumentVerificationType, VerifyMethodType } from "shared/types";

// A reverify request asks for both 1099 kinds as one method.
export type ReverifyDocType =
  | DocumentVerificationType.Paystub
  | DocumentVerificationType.W2
  | DocumentVerificationType.BankStatement
  | DocumentVerificationType.BenefitsStatement
  | VerifyMethodType.Form1099;

// Document types a partner can re-verify a single income with. Mirrors the API's
// Source::REVERIFY_TYPES: bank statements are excluded because their items are assigned to
// incomes in a separate step, so they cannot replace one income's verification on their own.
export enum DocType {
  Paystub = "paystub",
  W2 = "w2",
  Form1099 = "form_1099",
  BenefitsStatement = "benefits_statement"
}

export enum ReverifyFlows {
  SelectOption,
  ReVerifyWithDocuments,
  SendRequest
}

export enum VerificationType {
  Bank = "bank",
  Payroll = "payroll",
  Documents = "documents"
}
